import createAxiosInstance from '../createAxiosInstance';

const PRODUCT_API_URL = import.meta.env.VITE_API_URL_PRODUCT;

if (PRODUCT_API_URL === undefined) {
    throw new Error('Product API URL is not defined');
}

const axios = createAxiosInstance(PRODUCT_API_URL);

export default axios;
